import { render, staticRenderFns } from "./trendCard.vue?vue&type=template&id=8465f97a&scoped=true&"
import script from "./trendCard.vue?vue&type=script&lang=js&"
export * from "./trendCard.vue?vue&type=script&lang=js&"
import style0 from "./trendCard.vue?vue&type=style&index=0&id=8465f97a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8465f97a",
  null
  
)

export default component.exports